import {Injectable} from '@angular/core';
import {Constant} from '../../global/util/Constant';
import {HttpClient} from '@angular/common/http';
import {Headers} from '../../global/util/Headers';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
  private url = Constant.ROOT_API_V1.concat('/managements');

  constructor(private http: HttpClient) {
  }

  save(formData: FormData): Observable<any> {
    return this.http.post(this.url, formData);
  }
}
